import React from "react";
import ReactDOM from "react-dom";
import {PressReleases} from "../components/PressReleases";

export const insertPressReleases = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="press-releases"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<PressReleases />, element);
  });
};
